import { useCallback, useEffect, useLayoutEffect } from 'react';
import { DefaultLoadingManager } from 'three';
import { useLoadingStore, LoadingStatus } from '@/features/loading/stores/useLoadingStore';
import { PATH_TO_KEY } from '@/data/resources';

/**
 * Syncs Three.js DefaultLoadingManager with the loading store
 * Uses PATH_TO_KEY to map URLs to semantic resource keys for better debugging
 * Call this hook once in your app's loading provider
 */
export function useThreeLoader() {
  const setStatus = useLoadingStore((s) => s.setStatus);

  const updateStatus = useCallback((url: string, status: LoadingStatus) => {
    const key = PATH_TO_KEY.get(url);
      // dont set keys that are dynamic, let their custom loader handle that 
      if (key) 
      {
        setStatus(key, status);
      }
  }, [setStatus])

  useLayoutEffect(() => {
    DefaultLoadingManager.onStart = (url, loaded, total) => {
      console.log('Three.js loading started:', url, `${loaded}/${total}`);
    };

    DefaultLoadingManager.itemStart = (url) => {
      updateStatus(url, LoadingStatus.LOADING)
    };

    DefaultLoadingManager.itemEnd = (url) => {
      updateStatus(url, LoadingStatus.LOADED)
    };

    DefaultLoadingManager.itemError = (url) => {
      updateStatus(url, LoadingStatus.ERROR)
    };

    // Cleanup on unmount
    return () => {
      DefaultLoadingManager.onStart = () => {};
      DefaultLoadingManager.itemStart = () => {};
      DefaultLoadingManager.itemEnd = () => {};
      DefaultLoadingManager.itemError = () => {};
    };
  }, [setStatus, updateStatus]);
}
